import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import AuthGateway from '~apis/auth';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import navActions from '~utils/navActions';
import Utils from '~utils/functions';
import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchLogout(api: AuthGateway): SagaWatcherReturnType {
    yield takeEvery('auth/authLogoutAttempt', handleLogout, api);
}

function* handleLogout(api: AuthGateway) {
    let authToken = store.getState().auth.userDetails.authToken;
    if (!authToken) authToken = localStorage.getItem('authToken') || '';

    yield put(combinedActions.authClearEntireStore()); // clear entire redux state
    yield call(navActions.navToLogin);
    yield call(() => Utils.Auth.clearAuthToken());
    yield call(() => Utils.SessionStorage.removeItem('authTokenExp'));

    const response = yield* call([api, api.logout], { authToken });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.authLogoutFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const { data } = response;

        yield put(combinedActions.authLogoutSuccess(data));

        yield call(() => toast.success(SuccessMessages.LogoutSuccess));
    }
}
